import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { GraphService } from '~/core/services/graph.service';
import { AppConfigService } from '~/core/services/appconfig.service';
import { AppSettingsService } from '~/core/services/appsettings.service';
import { environment } from '../../../../../environments/environment';

import { AppSettings } from '~/core/models/appsettings';

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent {
    @Input() title = "Sentry";
    @Output() setLayoutCssClass = new EventEmitter();
    @Output() reloadPage = new EventEmitter();

    public appSettings: AppSettings = new AppSettings();
    public guideIconTitle = "Guide";
    public env: string = "";
    public itemsClass = "";
    public initials: string = "";
    public showPhoto: boolean = false;

    constructor(
        private router: Router,
        private graphService: GraphService,
        private appConfigService: AppConfigService,
        private appSettingsService: AppSettingsService
    ) {
        const configuredEnvironment = this.appConfigService.getConfig("environment");
        const isLocalHost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
        const resolvedEnvironment = (isLocalHost ? 'local' : (configuredEnvironment || environment.name || "")).toString().trim();

        if (resolvedEnvironment) {
            this.env = resolvedEnvironment.toLocaleUpperCase();
        }
    }

    //*************************************************************************
    //  Component Life-Cycle Methods
    //*************************************************************************
    public async ngOnInit() {
        await this.getUserInfo();
    }

    //*************************************************************************
    //  Public Methods
    //*************************************************************************
    public navigateTo(url: string) {
        if (url === '/guide') {
            const currentUrl = this.router.url.split('?')[0].split('#')[0];
            const scopedRunCitationsRouteMatch = currentUrl.match(/^\/refinery\/([^\/]+)\/unit\/([^\/]+)\/run\/([^\/]+)\/citations\/([^\/]+)(?:\/guide)?$/);

            if (scopedRunCitationsRouteMatch?.[1] && scopedRunCitationsRouteMatch?.[2] && scopedRunCitationsRouteMatch?.[3] && scopedRunCitationsRouteMatch?.[4]) {
                this.router.navigate([
                    '/refinery',
                    decodeURIComponent(scopedRunCitationsRouteMatch[1]),
                    'unit',
                    decodeURIComponent(scopedRunCitationsRouteMatch[2]),
                    'run',
                    decodeURIComponent(scopedRunCitationsRouteMatch[3]),
                    'citations',
                    decodeURIComponent(scopedRunCitationsRouteMatch[4]),
                    'guide'
                ]);
                return;
            }

            const runCitationsRouteMatch = currentUrl.match(/^\/run\/([^\/]+)\/citations\/([^\/]+)(?:\/guide)?$/);

            if (runCitationsRouteMatch?.[1] && runCitationsRouteMatch?.[2]) {
                this.router.navigate([
                    '/run',
                    decodeURIComponent(runCitationsRouteMatch[1]),
                    'citations',
                    decodeURIComponent(runCitationsRouteMatch[2]),
                    'guide'
                ]);
                return;
            }

            const runRouteMatch = currentUrl.match(/^\/run\/([^\/]+)(?:\/guide)?$/);

            if (runRouteMatch?.[1]) {
                this.router.navigate(['/run', decodeURIComponent(runRouteMatch[1]), 'guide']);
                return;
            }
        }

        this.router.navigateByUrl(url);
    }

    //*************************************************************************
    //  Private Methods
    //*************************************************************************
    private async getUserInfo() {
        this.appSettings = await this.appSettingsService.getSettings();

        if (this.appSettings.user?.photo !== "") {
            this.showPhoto = true;
        } else {
            this.graphService.getUserPhoto().then((photo: any) => {
                this.appSettings.user.photo = photo;

                if (photo !== "") {
                    this.showPhoto = true;
                }
    
                this.appSettingsService.saveSettings(this.appSettings);
            });
        }
    }
}
